import { getDuration } from '@/utils/duration'
import { Controller } from '@hotwired/stimulus'

export default class TimeEntryInputsContainerController extends Controller {
  static targets = ['startedAt', 'finishedAt', 'duration']

  updateDuration() {
    const startedAt = this.startedAtTarget.value || null
    const finishedAt = this.finishedAtTarget.value || null

    this.durationTarget.innerText = getDuration(startedAt, finishedAt)
  }
}
